export default {
  // fixed vuetify translation, DO NOT CHANGE
  noDataText: 'Žádné položky',

  navigation: {
    search: 'Hledání objednávek',
    check: 'Kontrola objednávek',
    packages: 'Balení objednávek',
  },

  user: {
    login: 'Přihlásit se',
    logout: 'Odhlásit se',
    logForm: 'Přihlašovací formulář',
    activationForm: 'Aktivační formulář',
    resetPasswordConfirmForm: 'Potvrzovací formulář pro obnovu hesla',
    activation: 'Aktivovat',
    passwordChange: 'Změnit heslo',
    forgottenPassword: 'Zapomenuté heslo',
    password: 'Heslo',
    passwordConfirm: 'Potvrzení hesla',
  },

  search: {
    orderById: 'Vyhledávání objednávky dle ID',
  },

  packages: {
    success1: 'Obj. č.',
    success2: 'byla úspěšně označena jako zabalená. Můžete pokračovat na další objednávku.',
    success3: 'byla úspěšně označena jako zabalená. Můžete pokračovat.',
    pieces: 'kusů',
    error: 'CHYBA',
    popup: {
      error: 'Chyba',
      info1: 'Objednávka',
      info2: 'nebyla označená jako probíhá kontrola.',
      ok: 'Rozumím',
    },
    continue: 'nebo pokračovat scanováním další obj.',
    message: 'Tato objednávka se nenachází ve stavu "Balí se"',
    badId: 'Nenašli jsme žádnou objednávku pod tímto ID.',
    actualId: 'Již máte vyhledanou objednávku pod tímto ID.',
    remains: 'Zbývá zabalit',
    todayPackaged: 'Dnes jsem zabalil/a',
  },

  check: {
    success1: 'Obj. č.',
    success2: 'byla úspěšně označena jako zkontrolovaná.',
    badId: 'Nenašli jsme žádnou objednávku pod tímto ID.',
    badStatus: 'Hledaná objednávka není ve stavu "Probíhá kontrola".',
    remains: 'Zbývá zkontrolovat',
    todayPackaged: 'Dnes jsem zkontroloval/a',
    note: 'Poznámka ke kontrole objednávky',
    hideSwitch: 'Skrýt zkontrolované produkty',
    checked: 'Zkontrolováno',
    error: 'Chyba',
    damaged: 'Poškozeno',
    systemError: 'Chyba systému',
    wrongSize: 'Špatná velikost',
    wrongInclusion: 'Špatné zařazení',
    other: 'Jiné',
    notFound: 'Nedohledáno',
    found: 'Dohledáno',
    orders: 'OBJEDNÁVEK',
    pieces: 'KUSŮ',
    close: 'Zavřít',
    uncheck: 'Odvolat',
    miss1: 'Označit položky: ',
    miss2: 'za chybu a vytvořit dobropis?',
    continue: 'Pokračovat',
    edit_order_credit_state: 'Upravit stav dobropisu',
  },

  searching: {
    selectedId: 'Tuto objednávku již máte ve výběru.',
    badId: 'Nenašli jsme žádnou objednávku pod tímto ID.',
    badStatus: 'Hledaná objednávka není ve stavu "Vychystává se".',
    todaySearched: 'Dnes jsem vyhledal/a',
    remains: 'Zbývá vyhledat',
    scan1: 'Objednávka ',
    scan2: ' naskenována.',
    orders: 'OBJEDNÁVEK',
    pieces: 'KUSŮ',
    selected: 'Vybrané objednávky',
    next: 'Začít vyhledávat',
    toSearch: 'ZBÝVÁ NALÉZT',
    searched: 'NALEZENO',
    from: 'z',
    noProducts: 'Již nejsou žádné další produkty',
    uncheck: 'Nalezeno',
    check: 'Označit',
    close: 'Zavřít',
    save: 'Uložit',
    miss1: 'U některých objednávek',
    miss2: 'chybí položky, opravdu chcete objednávku dokončit?',
    send: 'Přesto odeslat',
    success1: 'Obj. č.',
    success2: 'byla úspěšně označena jako probíhá kontrola. Můžete pokračovat na další objednávku.',
  },

  labels: {
    enter: 'Enter',
    escape: 'Escape',
    newCustomer: 'Nový zákazník',
    actualOrderState: 'Aktuální stav objednávky',
    stornoHandlingFee: 'Manipulační poplatek (storno)',
    companyName: 'Název společnosti',
    companyIdNumber: 'IČ',
    companyVatNumber: 'DIČ',
    dispensing: 'Výdejna',
    takeProfit: 'Inkasovat',
    shop: 'Expedice',
    settings: 'Nastavení účtu',
    clearMetadata: 'Vymazat mezipaměť',
    saveChanges: 'Vytvořit doklad',
    resetChanges: 'Zrušit změny',
    orderDate: 'Datum objednávky',
    orderState: 'Stav objednávky',
    paidAt: 'Zaplaceno',
    notPaidYet: 'Objednávka ještě nebyla zaplacena',
    ip: 'IP',
    showCustomersComments: 'Zobrazit komentáře k zákazníkovi',
    noNote: 'Zákazník nezanechal poznámku',
    noShopNote: 'Obchod nezanechal poznámku',
    showOnMap: ' Zobrazit na mapě',
    withoutWat: 'bez DPH',
    orderedItems: 'Položky objednávky',
    orderedItemsCount: '(celkem {0} produktů / {1} kusů)',
    weight: 'Váha',
    note: 'Poznámka',
    customerNote: 'Poznámka zákazníka',
    shopNote: 'Poznámka obchodu',
    info: 'Informace',
    subtotal: 'Mezisoučet',
    wat: 'DPH',
    typeOfOrder: 'Typ objednávky',
    shipping: 'Doprava',
    payment: 'Platba',
    total: 'Celkem',
    newTotal: 'Nová cena celkem',
    customer: 'Zákazník',
    notFilled: 'Nevyplněno',
    billingAddress: 'Fakturační adresa',
    shippingAddress: 'Dodací adresa',
    orderFound: 'Nalezena objednávky č.',
    goToOrder: 'Přejít na detail',
    logout: 'Odhlásit',
    send: 'Odeslat',
    customerRegistered: 'Registrovaný zákazník',
    stornoAll: 'Stornovat vše',
    orderId: 'Číslo objednávky',
    itemsCount: 'Počet položek',
    finalTaxedPrice: 'Finální celková cena',
    uncheckLastCheckedProduct: 'Odvolat',
  },

  messages: {
    order_id_too_long: 'Číslo objednávky je příliš dlouhé',
    noNote: 'Zákazník nezanechal poznámku',
    forSearchStartTyping: 'Pro vyhledávání začněte psát…',
    deleteConfirm: 'Opravdu si přejete smazat tuto položku',
    invalidData: 'Nevalidní data',
    fieldRequired: 'Pole je povinné',
    fieldLength: 'Pole přesahuje délku {0} znaků',
    greaterThanZero: 'Musí být větší než nula',
    lesserThan65535: 'Musí být menší než 65535',
    longerThanEight: 'Musí mít alespoň 8 znaků',
    passwordsMustMatch: 'Hesla se musejí shodovat',
    wrongEmailFormat: 'Neplatný formát e-mailu',
    messagesSent: 'Hromadná zpráva úspěšně odeslána',
    onlyHourAndMinutes: 'Zadejte pouze hodiny a minuty oddělené ":"',
    mustContainColon: 'Musí obsahovat ":"',
    passwordResetRequestSent: 'Žádost o obnovení hesla byla odeslána, odkaz pro nastavení nového hesla vám přijde na e-mail',
    creditNoteCreated: 'Dobropis byl úspěšně vytvořen',
    accessDenied: 'Pro tuto akci nemáte oprávnění',
    greaterThan: 'Hodnota musí být větší než {0}',
    attributeCreatedSuccessfully: 'Atribut úspěšně vytvořen',
    attributeUpdatedSuccessfully: 'Atribut úspěšně upraven',
    itemMovedSuccesfully: 'Položka přemístěna úspěšně',
    noCategories: 'Zatím nemáte žádnou kategorii',
    noMoreThanTwoTags: 'K inzerátu nelze přidat více jak dva štítky',
    mustContainDialCode: 'Telefon musí obsahovat i předvolbu',
    googleSignInRequired: 'Pro přístup k informacím je nejdříve nutné se přihlásit pomocí účtu napojeném na Google Analytics a vybrat časový interval',
    cameraNotAllowedError: 'Musíte povolit přístup ke kameře',
    cameraNotFoundError: 'Na tomto zařízeni nebyla nalezena kamera',
    cameraNotReadableError: 'Nepoužívate již kameru jinde?',
    cameraOverconstrainedError: 'Používaná kamera není vhodná',
    cameraStreamApiNotSupportedError: 'Váš prohlížeč nepodporuje toto rozhraní',
    confirmOrderChange: 'Potvrzením se vytvoří daňový doklad.',
    latestOrderChange: 'Obj. č. <strong>{0}</strong> na <strong>{1} ks</strong> celkem za <strong>{2}</strong> úspěšně upravena. Můžete pokračovat na další objednávku. ',
    confirmOrderCancellation: 'Potvrzením zrušíte objednávku č. <strong>{0}</strong>. <strong>Inkasovat nevratný manipulační poplatek {1}.</strong>',
    orderSuccessfullyUpdated: 'Objednávka byla úspěšně upravena',
    orderSuccessfullyCancelled: 'Objednávka byla úspěšně zrušena',
    carrier: 'Dobírka',
    successfulyCreated: 'Úspěšně vytvořeno',
    customerFound: 'Zákazník nalezen',
    customerNotFound: 'Zákazník nenalezen',
    creditsAdded: 'Úspěšně připsáno',
    invalidAmount: 'Zadejte prosím platnou hodnotu',
    updateError: 'Byla vydána nová verze aplikace, prosím přenačtěte si stránku.',
    qrCodeBlobError: 'Nepodařilo se vygenerovat pdf s QR kódem',
    imageError: 'Nepodařilo se načíst obrázek',
    ordersQualityAssuranceError: 'Nepodařilo se odeslat kontrolu objednávky',
    ordersQualityAssuranceFetchError: 'Nepodařilo se načíst objednávku ke kontrole',
    order_credit_state_set_to_valid: 'Stav dobropisu byl nastaven na "Platný"',
    error: 'Neočekávaná chyba'
  },

  basic: {
    yes: 'Ano',
    no: 'Ne',
    update: 'Aktualizovat',
    active: 'Aktivní',
    notActive: 'Neaktivní',
    solved: 'Odbaveno',
    notSolved: 'Neodbaveno',
    ok: 'OK',
    confirm: 'Potvrdit',
    cancel: 'Zrušit',
    create: 'Vytvořit',
    locked: 'Uzamčené',
    insertName: 'Vložte název',
    goToOrderDetail: 'Přejít na detail objednávky',
    name: 'Jméno',
    surname: 'Příjmení',
    email: 'E-mail',
    phone: 'Telefon',
    id: 'ID',
  },

  global: {
    ascending: 'Vzestupně',
    descending: 'Sestupně',
    sorting: 'Řazení',
  },

  errors: {
    allFields: 'Vyplňte všechna povinná pole',
    gdpr: 'Musíte udělit souhlas s obchodními podmínkami a se zpracováním osobních údajů',
    no_active_order_credit: 'Nemáte žádný aktivní dobropis',
    order_credit_state_update_failed: 'Nepodařilo se upravit stav dobropisu',
  },

  close: 'Zavřít',
};
